import React from "react";
import {
  ButtonContainer,
  ButtonWrapper,
  LogOutButtonElement,
} from "./styledLogoutButton";
import theme from "../../theme";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";

const LogOutButton = () => {
  const handleLogOutClick = () => {
    Cookies.remove("SES");
    // console.log("deleted");
  };

  return (
    <ButtonContainer>
      <ButtonWrapper>
        <Link to={"/login_s"}>
          <LogOutButtonElement
            onClick={handleLogOutClick}
            sx={{ color: "white", backgroundColor: theme.palette.primary.main }}
          >
            Log Out
          </LogOutButtonElement>
        </Link>
      </ButtonWrapper>
    </ButtonContainer>
  );
};

export default LogOutButton;
